module.exports = __webpack_public_path__ + "img/142ne.6b3aee98.svg";